<template>
  <button
      class="relative flex items-center justify-start gap-[4px] leading-7 w-fit h-fit py-0.5 px-2 text-complementary-300 text-base font-bold bg-complementary-900 rounded"
      @click="toggleTooltip"
  >
    <span class="material-symbols-rounded text-complementary-300 text-lg z-20"
    >live_help</span
    >
    <p>
      <span class="inline "> {{ tooltipHayadataTexts.title_bold + " " }}</span>
    </p>
    <tooltip-hayadata
        v-if="showTooltip"
        :class="[
        '!absolute left-0 top-[49px] z-30',
        openUp ? 'bottom-[49px] !top-[inherit]' : '',
      ]"
        :positionBottom="openUp"
        :positionLeft="positionLeft"
        :positionTop="!openUp"
        :tooltipHayadataTexts="tooltipHayadataTexts"
    ></tooltip-hayadata>
  </button>
</template>

<script>
import TooltipHayadata from "@/components/Global/TooltipHayadata.vue";

export default {
  name: "button-tooltip-hayadata",
  components: {TooltipHayadata},
  props: {
    tooltipHayadataTexts: {
      type: Object,
      default: {
        title_bold: " טוב לדעת! ",
        title_regular: " טולטיפ ",
        description:
            "חשוב לנו שההזמנה תהיה גמישה לשינויים ועריכה עד זמן הסגירה וכדי לא ליצור מצב ששיניתם משהו ובגלל ששכחתם ללחוץ שוב על כפתור התשלום כל ההזמנה לא תגיע וחבל.לכן כל מוצר שתכניסו להזמנה נשמר והתשלום מתבצע בצורה אוטומטית סמוך לאספקה כך גם נוכל להמנע מגביה מיותרת על מוצרים שלא סופקו.",
      },
    },
    openUp: {
      type: Boolean,
      default: false,
    },
    positionLeft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
      if (this.showTooltip) {
        document.addEventListener("click", this.hideTooltipOutside);
      } else {
        document.removeEventListener("click", this.hideTooltipOutside);
      }
    },
    hideTooltipOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showTooltip = false;
        document.removeEventListener("click", this.hideTooltipOutside);
      }
    },
  },
};
</script>

<style>
</style>